import TRANSLATIONS_EN_OLD from "../English";
import { Auth_EN } from "./Auth/auth";
import { Challenge_Criteria_EN } from "./Challenges/challenge.criteria";
import { Challenge_Overview_EN } from "./Challenges/challenge.overview";
import { Challenge_Single_EN } from "./Challenges/challenge.single";
import { Challenge_Toasts_EN } from "./Challenges/challenge.toasts";
import { Consent_EN } from "./Components/consent";
import { News_EN } from "./News/news";
import { PrecisionGame_EN } from "./PrecisionGame/precision.game";
import { Profile_EN } from "./Profile/profile";
import { Profile_Settings_EN } from "./Profile/profile.settings";
import { Errors_EN } from "./Utils/Errors";
import { Feedback_EN } from "./Utils/Feedback";
import { siteRoutes_EN } from "./Utils/siteRoutes";

const TRANSLATIONS_EN = {
  ...TRANSLATIONS_EN_OLD,

  // Auth
  ...Auth_EN,

  // Profile
  ...Profile_EN,
  ...Profile_Settings_EN,

  // Challenges
  ...Challenge_Overview_EN,
  ...Challenge_Single_EN,
  ...Challenge_Toasts_EN,
  ...Challenge_Criteria_EN,

  // News
  ...News_EN,

  // Components
  ...Consent_EN,

  // Precision Game
  ...PrecisionGame_EN,

  // Utils
  ...siteRoutes_EN,
  ...Errors_EN,
  ...Feedback_EN,
};

export default TRANSLATIONS_EN;
